import * as React from "react";
const SvgFiRrDart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dart_svg__a)">
      <path
        fill="#062147"
        d="M20 0h-1.757a3.98 3.98 0 0 0-2.83 1.172l-3.241 3.242A4.02 4.02 0 0 0 11 7.242v3.463c-3.266 2.415-7.581 5.633-8.121 6.174a2.99 2.99 0 0 0-.577 3.4l-2.01 2.014a1 1 0 0 0 1.415 1.414L3.714 21.7a2.96 2.96 0 0 0 3.407-.579C7.66 20.58 10.88 16.266 13.3 13h3.462a3.98 3.98 0 0 0 2.829-1.172l3.242-3.242A4.02 4.02 0 0 0 24 5.758V4a4 4 0 0 0-4-4M5.707 19.707a1.02 1.02 0 0 1-1.414 0 1 1 0 0 1 0-1.414c.339-.336 3-2.343 5.948-4.534-2.192 2.947-4.2 5.61-4.534 5.948M22 5.758a2 2 0 0 1-.586 1.414l-3.242 3.242a2 2 0 0 1-1.415.586H14.77l.99-1.348 3.946-3.945a1 1 0 1 0-1.414-1.414l-3.944 3.944-1.35.992V7.242a2 2 0 0 1 .587-1.414l3.242-3.242A2 2 0 0 1 18.243 2H20a2 2 0 0 1 2 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDart;
